<template>
  <fragment>
    <mc-app-header title="dailyChallenges">
      <template #left>
        <div class="level-item">
          <router-link
            class="button is-small is-primary is-outlined"
            to="/daily_challenges/new"
            >Add New</router-link
          >
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="daily-challenges section">
        <mc-paginated-list
          v-slot="{ items: dailyChallengesList }"
          resource-state="dailyChallenges"
        >
          <div v-if="dailyChallengesList.length === 0" class="box mc-container">
            <div class="content has-text-centered">
              No users available!
            </div>
          </div>
          <div v-else class="mc-container">
            <div
              v-for="dailyChallenge in dailyChallengesList"
              :key="dailyChallenge.id"
              class="daily-challenges__item box"
            >
              <div class="daily-challenges__item-desc">
                <div class="daily-challenges__item-title">
                  {{ dailyChallenge.name }}
                </div>
                <b-tag class="is-info">{{
                  displayDateFromTimestamp(dailyChallenge.date)
                }}</b-tag>
              </div>
              <a
                class="button is-link is-small"
                target="_blank"
                :href="
                  `https://admin.typeform.com/form/${
                    dailyChallenge.typeformId
                  }/create`
                "
              >
                <b-icon icon="open-in-new" size="is-small" />
                <span>edit on typeform</span>
              </a>
              <b-button
                class="is-small is-info"
                icon-left="content-copy"
                @click="copyDeepLink(dailyChallenge)"
              >
                Copy DeepLink
              </b-button>
            </div>
          </div>
        </mc-paginated-list>
      </div>
    </mc-app-body>
  </fragment>
</template>
<script>
const DEEP_LINK_DOMAIN = process.env.VUE_APP_DEEP_LINK_DOMAIN;

import { mapState } from 'vuex';

import { copyToClipboard } from '../../utils/string';
import { displayDateFromTimestamp } from '../../utils/time';
import { getTypeformURL } from '../../utils/typeform';

export default {
  computed: {
    ...mapState(['dailyChallenges'])
  },
  methods: {
    getDeepLink(typeformId) {
      return `${DEEP_LINK_DOMAIN}/typeformChallenge/${encodeURIComponent(
        getTypeformURL(typeformId)
      )}`;
    },
    copyDeepLink({ typeformId }) {
      console;
      copyToClipboard(this.getDeepLink(typeformId));
      this.$buefy.toast.open({
        message: 'Copied!',
        type: 'is-success'
      });
    },
    displayDateFromTimestamp
  }
};
</script>

<style lang="scss" scoped>
.daily-challenges {
  height: 100%;

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  &__item-desc {
    flex: 1 0 0;
  }

  &__item-title {
    margin-bottom: 0.5rem;
  }
}

.button:not(:last-child) {
  margin-right: 0.5rem;
}
</style>
